import { ANCHOR_TYPE, START_OR_END, FIXED_DATE_MODE, TIMING_MODE } from '../constants'
import { createLocalId } from './ids'
import { createDefaultAnchorOffset } from './anchorOffset'

export const createEmptyAnchor = (overrides = {}) => {
  const type = overrides.type || ANCHOR_TYPE.participantStartDate
  return {
    id: createLocalId('anchor'),
    type,
    instanceId: '',
    instanceIds: [],
    startOrEnd: START_OR_END.start,
    visitStatus: '',
    instrumentEvent: '',
    offset: createDefaultAnchorOffset(type),
    timingMode: TIMING_MODE.fromStartOfDay,
    fixedDate: { mode: FIXED_DATE_MODE.day, value: '' },
    ...overrides,
  }
}
